import { useContext } from 'react';
import { FullMapContext } from '@/providers/FullMapProvider';
import type { FullMapContextType } from '@/providers/FullMapProvider';

export default function useFullMap(): FullMapContextType {
  return useContext<FullMapContextType>(FullMapContext);
}
